import React, { useState } from 'react';
import { Box, TextField, Button, MenuItem, Divider } from '@mui/material';
import koLocale from 'date-fns/locale/ko';
import DateAdapter from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';

const ApprovalListBox = ({ formik }) => {
    const [searchStrtDt, setSearchStrtDt] = useState(null);
    const [searchEndDt, setSearchEndDt] = useState(null);

    const onChangeDate = (newValue, name) => {
        formik.setFieldValue(name, newValue);
    };

    return (
        <div>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    my: 1,
                }}
            >
                <Box
                    component="form"
                    noValidate
                    autoComplete="off"
                    sx={{
                        flexGrow: 1,
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                        mr: 2,
                    }}
                    onSubmit={formik.handleSubmit}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                            '& > :not(style)': { m: 1, width: '25ch' },
                        }}
                    >
                        <TextField
                            variant="standard"
                            required
                            select
                            id="searchKeyword"
                            name="searchKeyword"
                            label="검색키워드"
                            value={formik.values.searchKeyword}
                            onChange={formik.handleChange}
                            error={
                                formik.touched.searchKeyword &&
                                Boolean(formik.errors.searchKeyword)
                            }
                            helperText={
                                formik.touched.searchKeyword && formik.errors.searchKeyword
                            }
                        >
                            {/* <MenuItem value="">검색키워드</MenuItem>
                            <MenuItem value="docTyp">타입</MenuItem> */}
                           {/*<MenuItem value="docCd">문서번호</MenuItem>*/}
                            <MenuItem value="partnerInc">고객명</MenuItem>
                            <MenuItem value="cstNm">사업명</MenuItem>
                        </TextField>
                        <TextField
                            variant="standard"
                            required
                            id="searchWords"
                            name="searchWords"
                            label="검색어"
                            onChange={formik.handleChange}
                            error={
                                formik.touched.searchWords && Boolean(formik.errors.searchWords)
                            }
                            helperText={
                                formik.touched.searchWords && formik.errors.searchWords
                            }
                        />
                    </Box>
                    <Box>
                        <LocalizationProvider dateAdapter={DateAdapter} locale={koLocale}>
                            <DatePicker
                                label="검색 시작일"
                                inputFormat={'yyyy-MM-dd'}
                                mask={'____-__-__'}
                                id="searchStrtDt"
                                name="searchStrtDt"
                                value={formik.values.searchStrtDt || null} 
                                onChange={(newValue) => {
                                    setSearchStrtDt(newValue);
                                    formik.setFieldValue('searchStrtDt', newValue);
                                    onChangeDate(newValue, 'searchStrtDt');
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="standard"
                                        fullWidth
                                        error={
                                            formik.touched.searchStrtDt &&
                                            Boolean(formik.errors.searchStrtDt)
                                        }
                                        helperText={
                                            formik.touched.searchStrtDt && formik.errors.searchStrtDt
                                        }
                                    />
                                )}
                            />
                        </LocalizationProvider>
                    </Box>
                    <Box sx={{ mx: 2 }}>
                        <LocalizationProvider dateAdapter={DateAdapter} locale={koLocale}>
                            <DatePicker
                                label="검색 종료일"
                                inputFormat={'yyyy-MM-dd'}
                                mask={'____-__-__'}
                                id="searchEndDt"
                                name="searchEndDt"
                                value={formik.values.searchEndDt || null} 
                                onChange={(newValue) => {
                                    setSearchEndDt(newValue);
                                    formik.setFieldValue('searchEndDt', newValue);
                                    onChangeDate(newValue, 'searchEndDt');
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="standard"
                                        fullWidth
                                        error={
                                            formik.touched.searchEndDt &&
                                            Boolean(formik.errors.searchEndDt)
                                        }
                                        helperText={
                                            formik.touched.searchEndDt && formik.errors.searchEndDt
                                        }
                                    />
                                )}
                            />
                        </LocalizationProvider>
                    </Box>
                    <Box>
                        <Button
                            type="submit"
                            color="info"
                            variant="contained"
                            disabled={formik.isSubmitting}
                        >
                            검색
                        </Button>
                    </Box>
                </Box>
            </Box>
        </div>
    );
};

export default ApprovalListBox;
